// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-tab{
  padding-left: 15px;
}

.Card {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
}
.text-card {
  color: var(--Neutral-950, #020618);
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 72px; /* 360% */
}
.emoji-progrss {
  display: flex;
  width: 510px;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03),
    0px 12px 16px -4px rgba(16, 24, 40, 0.08);
}
.emoji-progress-defult {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px 8px 0px 0px;
  border-top: 1px solid var(--Neutral-300, #cbd5e1);
  border-right: 1px solid var(--Neutral-300, #cbd5e1);
  border-left: 1px solid var(--Neutral-300, #cbd5e1);
  background: var(--Neutral-50, #f8fafc);
}
.container-emoji {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}
.statement-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.frame-70 {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.text-frame75 {
  cursor: pointer;
  padding: 5px;
}

.text-frame75.selected {
  color: #0C8F63;
  font-weight: bold;
  background-color: #E2E8F0;
}
.text-name {
  color: var(--Neutral-500, #64748b);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 266.667% */
  color: var(--Neutral-500, #64748b);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
.bedge-emoji {
  display: flex;
  padding: 2px 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid #042a20;
  background: #edfcf5;
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 200% */
}
.emoji-text {
  align-self: stretch;
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; /* 160% */
}
.emoji-progrss-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  display: flex;
  width: 54px;
  align-items: center;
  gap: 8px;
}

.vertical-line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;  
  background-color: #e2e8f0;  
}




.bar-background {
  width: 100%;
  height: 100%;
  background-color: #e2e8f0;
}

.bar {
  position: relative;
  height: 16px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: #e2e8f0; /* This can be the same as background */
  margin: 16px 0;
}
.bar-fill {
  position: absolute;
  height: 100%;
  background-color: #0c8f63;
  transition: width 0.3s ease;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: inherit;
}

.text-frame75 {
  cursor: pointer;
  padding: 5px;
  text-align: center;
}

 /* Add these rules to hide all emojis by default */
.emoji-container > div {
  display: none;
}
/* Add these rules to hide all emojis by default */
.emoji-container p { /* Target the <p> elements holding the emojis */
  display: none;
}

/* Make the default emoji visible initially */
.emoji-container > div.defult p.emoji-defult {
  display: block; /* Or inline or inline-block */
}

/* Make other emojis visible when their parent div has the 'visible' class */
.emoji-container > div.stronglydisagree.visible p.emoji-stronglydisagree,
.emoji-container > div.disagree.visible p.emoji-disagree,
.emoji-container > div.neutral.visible p.emoji-neutral,
.emoji-container > div.agree.visible p.emoji-agree,
.emoji-container > div.stronglyagree.visible p.emoji-stronglyagree {
  display: block; /* Or inline or inline-block */
}

/* CSS for hiding/showing the vertical lines */
.vector1 > svg.hidden {
  display: none;
}

.vector1 > svg.visible {
  display: block; /* Or 'inline' or 'inline-block' depending on your layout */
}

/* Make the default emoji visible initially */
.emoji-container > div.defult {
  display: flex; /* Or any appropriate display like 'inline-flex', 'block' */
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}


.feedback-message {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  width: 300px;
  text-align: center;
  z-index: 1000;
}

.feedback-message.success {
  background-color: #28a745;
  color: white;
}

.feedback-message.error {
  background-color: #dc3545;
  color: white;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-8px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-8px); }
}

/* Style for the default emoji text */
.emoji-defult {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 40.5px;
  font-style: normal;
  font-weight: 400;
  line-height: 54px;
  cursor: pointer; /* Keep the cursor for interaction */
}

/* Make other emojis visible when their parent div has the 'visible' class */
.emoji-container > div.stronglydisagree {
  display: flex;
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}

.emoji-container > div.disagree {
  display: flex;
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}

.emoji-container > div.neutral {
  display: flex;
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}

.emoji-container > div.agree {
  display: flex;
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}

.emoji-container > div.stronglyagree {
  display: flex;
  padding: 0px 6.25px 0px 6.75px;
  justify-content: center;
  align-items: center;
  border-radius: 135px;
  background: var(--Primary-50, #edfcf5);
}

/* Style for the emoji text within the now visible divs */
.emoji-stronglydisagree p,
.emoji-disagree p,
.emoji-neutral p,
.emoji-agree p,
.emoji-stronglyagree p {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 40.5px;
  font-style: normal;
  font-weight: 400;
  line-height: 54px;
  cursor: pointer; /* Keep the cursor for interaction */
}
.emoji-option {
  opacity: 0.5;
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
}

.emoji-option.selected {
  opacity: 1;
  transform: scale(1.2);
}


/* CSS for hiding/showing the vertical lines */
.vector1 > svg.hidden {
  display: none;
}

.vector1 > svg.visible {
  display: block; /* Or 'inline' or 'inline-block' depending on your layout */
}
.line1 {
  width: 1px;

  flex-shrink: 0;
  fill: #0c8f63;
}
.line2 {
  height: 7px;
  background: #475569;
  fill: #475569;
}
.line3 {
  width: 1.5px;
  height: 9px;
  background: #475569;
  fill: #475569;
}
.line4 {
  width: 1.5px;
  height: 11px;
  background: #475569;
  fill: #475569;
}
.line5 {
  width: 1.5px;
  height: 13px;
  background: #475569;
  fill: #475569;
}
.frame-75 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-frame75 {
  width: 80px;
  color: var(--Neutral-700, #334155);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 160% */
}
.alert-emoji {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 0px 0px 8px 8px;
  border: 1px solid var(--Neutral-Neutral-300, #d1d5db);
  background: var(--Neutral-50, #f8fafc);
}
.stack-emoji {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.Stack-emoji-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.stack-text {
  color: var(--Neutral-Neutral-800, #1f2937);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
}
.card-button {
  display: flex;
  padding: 40px 0px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}
.card-btn-group {
  display: flex;
  width: 488px;
  max-width: 488px;
  align-items: center;
  gap: 24px;
}
.card-btn1 {
  display: flex;
  width: 160px;
  height: 48px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 0.5px solid var(--Neutral-300, #cbd5e1);
  background: var(--Neutral-100, #f1f5f9);
}
.btn1-text {
  color: var(--Neutral-950, #020618);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: var(--Label-Large-Line-Height, 20px); /* 125% */
  letter-spacing: var(--Label-Large-Tracking, 0.1px);
}
.revist-icon {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 2px 1px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
}
.card-btn2 {
  display: flex;
  height: 48px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  border-radius: 4px;
  border: 0.5px solid #0a5b42;
  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);
}
.btn2-text {
  color: #f8fafc;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: var(--Label-Large-Line-Height, 20px); /* 125% */
  letter-spacing: var(--Label-Large-Tracking, 0.1px);
}
.arrow {
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
}


@media (max-width: 768px) {
  .tab-bar {
    gap: 0.5rem;
    justify-content: flex-start;
  }
  .card{
    margin-right: 10px;
  }

  .tab-item {
    width: 45%;
    margin-bottom: 0.5rem;
    flex: 1 0 auto;
  }

  .task-progress-container {
    margin-top: 1.25rem;
  }
    .emoji-progrss {
        margin-top: 1rem;
    }
    .card-btn-group {
        gap: 1rem;
    }
}

@media (max-width: 600px) {
  .tab-bar {
    flex-direction: column;
    align-items: center;
  }
  .card{
    margin-right: 10px;
  }

  .tab-item {
    width: 90%;
    margin-bottom: 0.5rem;
    flex: 0 0 auto;
  }

  .task-progress-container {
    margin-top: 1.25rem;
  }

  .text-card {
    font-size: 1rem;
    line-height: 2rem;
  }

  .emoji-text {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .text-name {
    font-size: 0.75rem;
    line-height: 1.5rem;
  }

  .bedge-emoji {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }

  .stack-text {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .btn1-text,
  .btn2-text {
    font-size: 0.9rem;
  }
    .emoji-progrss {
        width: 95%;
        margin-top: 1rem;
    }
    .card-btn-group {
        flex-direction: column;
        gap: 1rem;
    }
    .card-btn1, .card-btn2 {
        width: 100%;
        max-width: 100%;
    }
}

@media (max-width: 480px) {
  .tab-bar{
    display: none;
  }
  .bedge-emoji{ 
    font-size: 0.6rem;
  }
  .text-card{
    margin-top: 1rem;
  }
  .emoji-text{
    font-size:0.8rem
  }
  .bar{
    width: 78vw;
  }
  .frame-75{
    width: 78vw;
  }
  .emoji-progrss{
    width: 90vw;
    margin-right:0.8rem
  }
  .card-btn1{
    width:80vw;
  }
  .card-btn2{
    width:80vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Components/Card.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB;6CAC2C;AAC7C;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;EACjD,mDAAmD;EACnD,kDAAkD;EAClD,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;;;;AAKA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAE,uCAAuC;EAClE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,MAAM;EACN,OAAO;EACP,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;CAEC,kDAAkD;AACnD;EACE,aAAa;AACf;AACA,kDAAkD;AAClD,qBAAqB,+CAA+C;EAClE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,cAAc,EAAE,8BAA8B;AAChD;;AAEA,4EAA4E;AAC5E;;;;;EAKE,cAAc,EAAE,8BAA8B;AAChD;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,2DAA2D;AAC7E;;AAEA,6CAA6C;AAC7C;EACE,aAAa,EAAE,2DAA2D;EAC1E,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;EAC9C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe,EAAE,oCAAoC;AACvD;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,yDAAyD;AACzD;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe,EAAE,oCAAoC;AACvD;AACA;EACE,YAAY;EACZ,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;;AAGA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,2DAA2D;AAC7E;AACA;EACE,UAAU;;EAEV,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,qDAAqD;EACrD,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;AACzC;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD,EAAE,SAAS;EAC5D,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,SAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,gEAAgE;AAClE;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD,EAAE,SAAS;EAC5D,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;IACE;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;IACE;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE;EACF;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX;EACF;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".card-tab{\n  padding-left: 15px;\n}\n\n.Card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n}\n.text-card {\n  color: var(--Neutral-950, #020618);\n  text-align: center;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 72px; /* 360% */\n}\n.emoji-progrss {\n  display: flex;\n  width: 510px;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03),\n    0px 12px 16px -4px rgba(16, 24, 40, 0.08);\n}\n.emoji-progress-defult {\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  align-self: stretch;\n  border-radius: 8px 8px 0px 0px;\n  border-top: 1px solid var(--Neutral-300, #cbd5e1);\n  border-right: 1px solid var(--Neutral-300, #cbd5e1);\n  border-left: 1px solid var(--Neutral-300, #cbd5e1);\n  background: var(--Neutral-50, #f8fafc);\n}\n.container-emoji {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n}\n.statement-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n}\n.frame-70 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n}\n.text-frame75 {\n  cursor: pointer;\n  padding: 5px;\n}\n\n.text-frame75.selected {\n  color: #0C8F63;\n  font-weight: bold;\n  background-color: #E2E8F0;\n}\n.text-name {\n  color: var(--Neutral-500, #64748b);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 266.667% */\n  color: var(--Neutral-500, #64748b);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n.bedge-emoji {\n  display: flex;\n  padding: 2px 10px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid #042a20;\n  background: #edfcf5;\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px; /* 200% */\n}\n.emoji-text {\n  align-self: stretch;\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px; /* 160% */\n}\n.emoji-progrss-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  display: flex;\n  width: 54px;\n  align-items: center;\n  gap: 8px;\n}\n\n.vertical-line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;  \n  background-color: #e2e8f0;  \n}\n\n\n\n\n.bar-background {\n  width: 100%;\n  height: 100%;\n  background-color: #e2e8f0;\n}\n\n.bar {\n  position: relative;\n  height: 16px;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #e2e8f0; /* This can be the same as background */\n  margin: 16px 0;\n}\n.bar-fill {\n  position: absolute;\n  height: 100%;\n  background-color: #0c8f63;\n  transition: width 0.3s ease;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  border-radius: inherit;\n}\n\n.text-frame75 {\n  cursor: pointer;\n  padding: 5px;\n  text-align: center;\n}\n\n /* Add these rules to hide all emojis by default */\n.emoji-container > div {\n  display: none;\n}\n/* Add these rules to hide all emojis by default */\n.emoji-container p { /* Target the <p> elements holding the emojis */\n  display: none;\n}\n\n/* Make the default emoji visible initially */\n.emoji-container > div.defult p.emoji-defult {\n  display: block; /* Or inline or inline-block */\n}\n\n/* Make other emojis visible when their parent div has the 'visible' class */\n.emoji-container > div.stronglydisagree.visible p.emoji-stronglydisagree,\n.emoji-container > div.disagree.visible p.emoji-disagree,\n.emoji-container > div.neutral.visible p.emoji-neutral,\n.emoji-container > div.agree.visible p.emoji-agree,\n.emoji-container > div.stronglyagree.visible p.emoji-stronglyagree {\n  display: block; /* Or inline or inline-block */\n}\n\n/* CSS for hiding/showing the vertical lines */\n.vector1 > svg.hidden {\n  display: none;\n}\n\n.vector1 > svg.visible {\n  display: block; /* Or 'inline' or 'inline-block' depending on your layout */\n}\n\n/* Make the default emoji visible initially */\n.emoji-container > div.defult {\n  display: flex; /* Or any appropriate display like 'inline-flex', 'block' */\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n\n.feedback-message {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 16px;\n  width: 300px;\n  text-align: center;\n  z-index: 1000;\n}\n\n.feedback-message.success {\n  background-color: #28a745;\n  color: white;\n}\n\n.feedback-message.error {\n  background-color: #dc3545;\n  color: white;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-8px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; }\n  100% { opacity: 0; transform: translateY(-8px); }\n}\n\n/* Style for the default emoji text */\n.emoji-defult {\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 40.5px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 54px;\n  cursor: pointer; /* Keep the cursor for interaction */\n}\n\n/* Make other emojis visible when their parent div has the 'visible' class */\n.emoji-container > div.stronglydisagree {\n  display: flex;\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n.emoji-container > div.disagree {\n  display: flex;\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n.emoji-container > div.neutral {\n  display: flex;\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n.emoji-container > div.agree {\n  display: flex;\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n.emoji-container > div.stronglyagree {\n  display: flex;\n  padding: 0px 6.25px 0px 6.75px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 135px;\n  background: var(--Primary-50, #edfcf5);\n}\n\n/* Style for the emoji text within the now visible divs */\n.emoji-stronglydisagree p,\n.emoji-disagree p,\n.emoji-neutral p,\n.emoji-agree p,\n.emoji-stronglyagree p {\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 40.5px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 54px;\n  cursor: pointer; /* Keep the cursor for interaction */\n}\n.emoji-option {\n  opacity: 0.5;\n  cursor: pointer;\n  transition: transform 0.2s, opacity 0.2s;\n}\n\n.emoji-option.selected {\n  opacity: 1;\n  transform: scale(1.2);\n}\n\n\n/* CSS for hiding/showing the vertical lines */\n.vector1 > svg.hidden {\n  display: none;\n}\n\n.vector1 > svg.visible {\n  display: block; /* Or 'inline' or 'inline-block' depending on your layout */\n}\n.line1 {\n  width: 1px;\n\n  flex-shrink: 0;\n  fill: #0c8f63;\n}\n.line2 {\n  height: 7px;\n  background: #475569;\n  fill: #475569;\n}\n.line3 {\n  width: 1.5px;\n  height: 9px;\n  background: #475569;\n  fill: #475569;\n}\n.line4 {\n  width: 1.5px;\n  height: 11px;\n  background: #475569;\n  fill: #475569;\n}\n.line5 {\n  width: 1.5px;\n  height: 13px;\n  background: #475569;\n  fill: #475569;\n}\n.frame-75 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.text-frame75 {\n  width: 80px;\n  color: var(--Neutral-700, #334155);\n  text-align: center;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 160% */\n}\n.alert-emoji {\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  border-radius: 0px 0px 8px 8px;\n  border: 1px solid var(--Neutral-Neutral-300, #d1d5db);\n  background: var(--Neutral-50, #f8fafc);\n}\n.stack-emoji {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n.Stack-emoji-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n.stack-text {\n  color: var(--Neutral-Neutral-800, #1f2937);\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 166.667% */\n}\n.card-button {\n  display: flex;\n  padding: 40px 0px;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  align-self: stretch;\n}\n.card-btn-group {\n  display: flex;\n  width: 488px;\n  max-width: 488px;\n  align-items: center;\n  gap: 24px;\n}\n.card-btn1 {\n  display: flex;\n  width: 160px;\n  height: 48px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 0.5px solid var(--Neutral-300, #cbd5e1);\n  background: var(--Neutral-100, #f1f5f9);\n}\n.btn1-text {\n  color: var(--Neutral-950, #020618);\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: var(--Label-Large-Line-Height, 20px); /* 125% */\n  letter-spacing: var(--Label-Large-Tracking, 0.1px);\n}\n.revist-icon {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  padding: 2px 1px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  aspect-ratio: 1/1;\n}\n.card-btn2 {\n  display: flex;\n  height: 48px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  border-radius: 4px;\n  border: 0.5px solid #0a5b42;\n  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);\n}\n.btn2-text {\n  color: #f8fafc;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: var(--Label-Large-Line-Height, 20px); /* 125% */\n  letter-spacing: var(--Label-Large-Tracking, 0.1px);\n}\n.arrow {\n  width: 32px;\n  height: 32px;\n  aspect-ratio: 1/1;\n}\n\n\n@media (max-width: 768px) {\n  .tab-bar {\n    gap: 0.5rem;\n    justify-content: flex-start;\n  }\n  .card{\n    margin-right: 10px;\n  }\n\n  .tab-item {\n    width: 45%;\n    margin-bottom: 0.5rem;\n    flex: 1 0 auto;\n  }\n\n  .task-progress-container {\n    margin-top: 1.25rem;\n  }\n    .emoji-progrss {\n        margin-top: 1rem;\n    }\n    .card-btn-group {\n        gap: 1rem;\n    }\n}\n\n@media (max-width: 600px) {\n  .tab-bar {\n    flex-direction: column;\n    align-items: center;\n  }\n  .card{\n    margin-right: 10px;\n  }\n\n  .tab-item {\n    width: 90%;\n    margin-bottom: 0.5rem;\n    flex: 0 0 auto;\n  }\n\n  .task-progress-container {\n    margin-top: 1.25rem;\n  }\n\n  .text-card {\n    font-size: 1rem;\n    line-height: 2rem;\n  }\n\n  .emoji-text {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n\n  .text-name {\n    font-size: 0.75rem;\n    line-height: 1.5rem;\n  }\n\n  .bedge-emoji {\n    font-size: 0.75rem;\n    line-height: 1.25rem;\n  }\n\n  .stack-text {\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n\n  .btn1-text,\n  .btn2-text {\n    font-size: 0.9rem;\n  }\n    .emoji-progrss {\n        width: 95%;\n        margin-top: 1rem;\n    }\n    .card-btn-group {\n        flex-direction: column;\n        gap: 1rem;\n    }\n    .card-btn1, .card-btn2 {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n  .tab-bar{\n    display: none;\n  }\n  .bedge-emoji{ \n    font-size: 0.6rem;\n  }\n  .text-card{\n    margin-top: 1rem;\n  }\n  .emoji-text{\n    font-size:0.8rem\n  }\n  .bar{\n    width: 78vw;\n  }\n  .frame-75{\n    width: 78vw;\n  }\n  .emoji-progrss{\n    width: 90vw;\n    margin-right:0.8rem\n  }\n  .card-btn1{\n    width:80vw;\n  }\n  .card-btn2{\n    width:80vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
